module.exports = __webpack_public_path__ + "static/img/tjbgchuang.92671b4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner/tjbgchuang.jpg
// module id = vF08
// module chunks = 9